import React from "react";
import "./commonServices.css";
import ITloading from "../../Loading/ITloading";

const ITservices = () => {
  return (
    <div className="it_services">
      <div className="it_left">
        <ITloading />
      </div>
      <div className="it_right">
        <span className="service-category">Design & Development</span>
        <h2>Intelligent IT Solutions for Modern Business</h2>
        <p>
          We are a top-tier IT powerhouse delivering robust architectures and
          seamless digital transformations. By mapping high-quality services to
          your unique business DNA, we utilize the latest cross-platform stacks
          to modernize, optimize, and scale your operations.
        </p>
        <div className="data_it">
          <p>Web App Architecture</p>
          <p>Enterprise Desktop Apps</p>
          <p>Native & Hybrid Mobile</p>
          <p>High-Availability APIs</p>
          <p>Microservices Design</p>
          <p>Automated QA Systems</p>
        </div>
      </div>
    </div>
  );
};

export default ITservices;
